export default __webpack_public_path__ + "static/media/GP.26105d7c.png";